import { msg } from '../../localization/i18n';

export const STATE_PANEL_PRESET_TITLES = {
  loading: () => msg('general.states.loading_title'),
  'occasion-not-available': () =>
    msg('general.states.occasion_not_available_title'),
  'feature-unavailable': () => msg('general.states.feature_unavailable_title'),
  'access-unavailable': () => msg('general.states.access_unavailable_title'),
  'unknown-error': () => msg('general.states.unknown_error_title'),
  'not-found': () => msg('general.states.not_found_title'),
  empty: () => msg('general.states.empty_title'),
  'no-results': () => msg('general.states.no_results_title'),
} as const;
